import { Component, OnInit } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { RouterOutlet } from '@angular/router';
import { SessionService } from './shared/service/session.service';
import { SessionWarningModalComponent } from './shared/component/session-warning-modal/session-warning-modal.component';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SessionWarningModalComponent, CommonModule],
  template: `
    <router-outlet></router-outlet>
    <app-session-warning-modal
      *ngIf="showWarning"
      (continueSession)="continueSession()"
    ></app-session-warning-modal>
  `,
})
export class AppComponent implements OnInit {
  showWarning: boolean = false;
  title: string = 'appcwcodijobs';

  constructor(private meta: Meta, private sessionService: SessionService) {
    if (!environment.production) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
  }

  ngOnInit() {
    this.sessionService.warning$.subscribe(() => {
      this.showWarning = true;
    });
  }

  continueSession() {
    this.showWarning = false;
    this.sessionService.keepAlive();
  }
}
